import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaFlowCheckpointImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.FLOW_CHECKPOINT;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (preguntaPadre.condiciones != null && preguntaPadre.condiciones !== "") {
            pasoTests = false;
            this.errores.push(`La columna ##Visible si debe estar vacía en la fila ${preguntaPadre.idPregunta}`);
        }
        return pasoTests;
    }
}
